import React from 'react';
import { T } from '../../../helpers/i18n';
import { Texto } from '../Texto';
import { toDateTime } from '../../../helpers/Format';
export var BlockUserRefund = function (_a) {
    var ticket = _a.ticket, align = _a.align, fontSize = _a.fontSize, bold = _a.bold;
    return (React.createElement("div", { style: { width: '100%', textAlign: align } },
        ticket.userNameRefund && React.createElement(Texto, { texto: "".concat(T('refundBy'), " ").concat(ticket.userNameRefund), align: align, fontSize: fontSize, bold: bold }),
        React.createElement(Texto, { texto: "".concat(toDateTime(ticket.daterefund)), align: align, fontSize: fontSize, bold: bold })));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockUserRefund.tsx
// module id = 1194
// module chunks = 0